import React, { useState } from 'react'
import './App.css';
import { generateMeditation } from './utils'
import styles from './styles'

const App = () => {
  const { romanNumeral, meditation } = generateMeditation()
  const isArrayMeditation = Array.isArray(meditation)
  const [isDonation, setIsDonation] = useState(false)

  return (
    <div className="App">
      <header className="App-header" style={styles.appHeader}>
        <span style={styles.romanNumeral}>
          {romanNumeral}
        </span>

        {isArrayMeditation && meditation?.map(line => (
          <span style={styles.meditation}>{line}</span>
        ))}
        {!isArrayMeditation && <span style={styles.meditation}>{meditation}</span>}
        <span style={styles.spacer} />
      </header>
    </div>
  );
}

export default App;
